/* eslint-disable max-lines */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable no-undef */
/* eslint-disable max-lines */

import _ from "lodash";
import { getProductsClusters } from "../utils/productsClusters";
import { sortSizes } from "../utils/sizes";
import { getDeliveryPeriodsForEan } from "./productsDelivery";
import { getCurrentOrder } from "./orders";

export const getSeasons = (context) => _.get(context, "entities.seasons");

export const getProductsByNumber = (context) => {
  const cached = global.productsByNumber;
  if (cached && Object.keys(cached).length > 0) return cached;

  const products = _.get(context, "entities.products");
  const v = _.values(products).reduce((obj, item) => {
    if (_.isObject(item)) return { ...obj, ...item };
    return obj;
  }, {});

  global.productsByNumber = v;
  return v;
};

export const getProductsAvailableClusters = (context) =>
  _.get(context, "entities.availableClusters") || [];

export const getProductsByNumberForSeason = (context) => (season) => {
  const products = _.get(context, "entities.products");
  const productsForSeason = _.get(products, season) || {};

  return productsForSeason;
};

export const getProductsByNumberForSeasonAndNOS = (context) => (season) => {
  const products = _.get(context, "entities.products");

  const getProductsForSeason = () => _.get(products, season) || {};
  const getProductsForNos = () => _.get(products, "NOS");
  const getProductsForWM = () => _.get(products, "WM");

  if (season === "NOS") {
    return getProductsForNos();
  }

  if (season === "WM") {
    return getProductsForWM();
  }

  return {
    ...getProductsForSeason(),
    ...getProductsForNos(),
    ...getProductsForWM(),
  };
};

global.seasonNumberMap = {};

export const getSeasonForProduct = ({ context, number }) => {
  const map = {};

  if (Object.keys(global.seasonNumberMap).length === 0) {
    const products = _.get(context, "entities.products");
    const seasons = Object.keys(products);
    seasons.forEach((s) => {
      const ps = Object.keys(products[s]);
      ps.forEach((n) => {
        let x = map[n];

        if (!x) {
          x = [];
        }

        x.push(s);
        map[n] = x;
      });
    });

    global.seasonNumberMap = map;
  }

  return global.seasonNumberMap[number][0] || "NOS";
};

export const getProductForNumber = (context) => (number) => {
  const productsByNumber = getProductsByNumber(context);
  return productsByNumber[number];
};

const hasDeliveryDate = ({ deliveryDates, deliveryDate }) =>
  _.get(deliveryDates, _.get(deliveryDate, "value")) !== undefined;

export const getProductColorsForNumber =
  (context) => (number, deliveryDate) => {
    const product = getProductForNumber(context)(number);

    if (!product) return [];

    const seenColors = new Set();

    const mappedColors = _.keys(product).map((ean) => {
      const p = product[ean];
      if (deliveryDate) {
        const deliveryDates = getDeliveryPeriodsForEan({ context, ean });
        if (!hasDeliveryDate({ deliveryDates, deliveryDate })) {
          return null;
        }
      }

      if (p && p.c) {
        if (!seenColors.has(p.c)) {
          seenColors.add(p.c);

          return { code: p.c, hex: p.h, desc: p.desc };
        }
      }

      return null;
    });

    return _.sortedUniq([...new Set(_.compact(mappedColors))]);
  };

export const getProductSizesByLengthForNumber =
  (context) => (number, deliveryDate) => {
    const product = getProductForNumber(context)(number);

    if (!product) return {};

    const r = {};

    _.keys(product).forEach((ean) => {
      const p = product[ean];
      if (deliveryDate) {
        const deliveryDates = getDeliveryPeriodsForEan({ context, ean });
        if (!hasDeliveryDate({ deliveryDates, deliveryDate })) {
          return;
        }
      }

      if (p && p.l && p.s) {
        if (r[p.l] === undefined || r[p.l] === null) {
          r[p.l] = [];
        }

        r[p.l].push(p.s);
      }
    });

    _.each(Object.keys(r), (k) => {
      r[k] = sortSizes(_.uniq(_.compact(r[k])));
    });

    return r;
  };

export const getProductSizesForNumber = (context) => (number, deliveryDate) => {
  const product = getProductForNumber(context)(number);

  if (!product) return [];
  const mappedSizes = _.keys(product).map((ean) => {
    const p = product[ean];
    if (deliveryDate) {
      const deliveryDates = getDeliveryPeriodsForEan({ context, ean });
      if (!hasDeliveryDate({ deliveryDates, deliveryDate })) {
        return null;
      }
    }
    if (p && p.s) return p.s;
    return null;
  });

  return _.uniq(_.compact(mappedSizes));
};

global.eanByNumberColorAndSize = {};

export const getEanForColorAndSize = ({ context, number, color, size }) => {
  const cached = global.eanByNumberColorAndSize[color + size + number];
  if (cached) return cached;

  const eans = getProductForNumber(context)(number);
  if (!eans) return null;

  const eanKey = _.findIndex(
    _.values(eans),
    (p) => p && p.c === color && p.s === size,
  );
  if (!eanKey) return null;

  const ean = _.keys(eans)[eanKey];
  global.eanByNumberColorAndSize[color + size + number] = ean;
  return ean;
};

export const filterProductByCluster = ({ product, clusters }) => {
  if (!product) return null;
  if (!clusters) return product;
  const clustersForProduct = getProductsClusters(product);
  let containAllClusters = true;
  clusters.split("|").forEach((cluster) => {
    if (!clustersForProduct.includes(cluster.trim()))
      containAllClusters = false;
  });
  return containAllClusters ? product : null;
};

export const getProductForMaterialNumber = (context) => (materialNumber) => {
  const order = getCurrentOrder(context);

  if (!order) return null;

  const values = _.values(
    getProductsByNumberForSeasonAndNOS(context)(order.doc.season),
  );

  const product = values.find((v) => v.mat.includes(materialNumber));

  const data = product ? [product] : [];

  return {
    data,
    pages: 1,
  };
};

export const getProductForEan = (context) => (ean) => {
  const order = getCurrentOrder(context);

  if (!order) return null;

  const values = _.values(
    getProductsByNumberForSeasonAndNOS(context)(order.doc.season),
  );

  const product = values.find((v) => {
    const have = _.keys(v).find((e) => e === ean);

    return !!have && have !== -1;
  });

  const data = product ? [product] : [];

  return {
    data,
    pages: 1,
  };
};

export const getProductsImages = (context) => {
  const products = _.values(getProductsByNumber(context));

  const images = products.reduce((i, currentProduct) => {
    _.values(currentProduct).forEach((p) => {
      if (p && p.f) i.push(p.f);
      if (p && p.b) i.push(p.b);
    });

    return i;
  }, []);

  return _.compact(images);
};

export const getColorAndSizeForEan = ({ context, eanKey, number }) => {
  const product = getProductsByNumber(context)[number];
  const ean = _.get(product, eanKey);

  if (!ean) return {};
  return { color: ean.c, size: ean.s };
};

export const getCollInfo = (context) => _.get(context, "entities.collInfo");

export const getCollInfoForProduct = (context, product) => {
  const infoColl = getCollInfo(context);

  return infoColl[product.number];
};
const findFirstProductForColor = (product, color) => {
  const os = Object.values(product);
  let selected = null;
  for (let i = 0; i < os.length; i++) {
    const p = os[i];
    if (!p.c || !p.f) {
      // must have a colour and front image
      continue;
    }

    if (color) {
      if (color === p.c) {
        selected = p;
        break;
      }
      continue;
    }

    selected = p;
    break;
  }

  if (selected === null) {
    for (let i = 0; i < os.length; i++) {
      const p = os[i];
      if (!p.c || !p.f) {
        // must have a colour and front image
        continue;
      }
      selected = p;
      break;
    }
  }

  return selected;
};

export const getProductFrontImageForNumber = (context) => (number, color) => {
  const product = getProductForNumber(context)(number);
  const item = findFirstProductForColor(product, color);

  return {
    front: _.get(item, "f"),
    back: _.get(item, "b"),
  };
};
